import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'wwe_splitio_key';
const COOKIE_KEY = 'wwe_splitio_key';

function readCookie(name: string): string | null {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'),
    );
    return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name: string, value: string) {
    if (typeof document === 'undefined') return;
    const maxAge = 60 * 60 * 24 * 365;
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

/** Stable Split traffic key so the SDK is not re-keyed every page load. */
export function getOrCreateSplitKey(): string {
    if (typeof window === 'undefined') {
        return uuidv4();
    }
    try {
        const fromLs = window.localStorage.getItem(STORAGE_KEY);
        if (fromLs) return fromLs;
        const fromCookie = readCookie(COOKIE_KEY);
        if (fromCookie) {
            window.localStorage.setItem(STORAGE_KEY, fromCookie);
            return fromCookie;
        }
        const key = uuidv4();
        window.localStorage.setItem(STORAGE_KEY, key);
        writeCookie(COOKIE_KEY, key);
        return key;
    } catch {
        return readCookie(COOKIE_KEY) || uuidv4();
    }
}
